// extracted by mini-css-extract-plugin
module.exports = {"image":"CartImage_image__z3k5B"};